import * as React from "react";
//import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import styles from "./styles.module.scss";
import "./selectLSC.scss";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";

const SelectLSC = (props) => {
  const realValues = props.optionRealValues || [];

  const handleChange = (event) => {
    props.onChange(event);
  };

  return (
    <div>
      <StyledEngineProvider injectFirst>
        <FormControl>
          <Select
            value={props.inputValue}
            onChange={handleChange}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            className="Select"
          >
            {props.optionValues &&
              props.optionValues.map((optionValue, i) => {
                return (
                  <MenuItem
                    value={
                      realValues[i] !== undefined ? realValues[i] : optionValue
                    }
                    key={i}
                  >
                    {optionValue}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </StyledEngineProvider>
    </div>
  );
};

export default SelectLSC;
